import React, { useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import {
  Container,
  Row,
  Col,
  Offcanvas,
  Button,
  Form,
  Dropdown,
} from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";

const products = [
  {
    id: 1,
    category: "earrings",
    slug: "earrings",
    name: "Gold Charm Bracelet",
    price: 2499,
    discountPrice: 1799,
    img: "/assets/images/product/medium-size/earring-5.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 2,
    category: "earrings",
    slug: "earrings",
    name: "Classic Gold Ring",
    price: 1999,
    discountPrice: 1399,
    img: "/assets/images/product/medium-size/earring-3.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 3,
    category: "earrings",
    slug: "earrings",
    name: "Diamond Drop Earrings",
    price: 2999,
    discountPrice: 2199,
    img: "/assets/images/product/medium-size/earring-1.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 4,
    category: "earrings",
    slug: "earrings",
    name: "Elegant Gold Necklace",
    price: 3499,
    discountPrice: 2599,
    img: "/assets/images/product/medium-size/earring-2.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 5,
    category: "earrings",
    slug: "earrings",
    name: "Elegant Gold Necklace",
    price: 3499,
    discountPrice: 2599,
    img: "/assets/images/product/medium-size/earring-6.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 6,
    category: "earrings",
    slug: "earrings",
    name: "Elegant Gold Necklace",
    price: 3499,
    discountPrice: 2599,
    img: "/assets/images/product/medium-size/earring-4.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 7,
    category: "necklaces",
    slug: "necklaces",
    name: "Elegant Gold Necklace",
    price: 3499,
    discountPrice: 2599,
    img: "/assets/images/product/medium-size/necklace-1.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
  {
    id: 8,
    category: "earrings",
    slug: "earrings",
    name: "Elegant Gold Necklace",
    price: 3499,
    discountPrice: 2599,
    img: "/assets/images/product/medium-size/earring-7.jpg",
    hoverImg: "/assets/images/product/medium-size/1-9.jpg",
  },
];

const ProductList = () => {
  const [showFilter, setShowFilter] = useState(false);

  return (
    <section className="" style={{ background: "#f5f5f5" }}>
      <Container
        fluid
        className="d-flex align-items-center justify-content-center text-white"
        style={{
          backgroundImage:
            "url('/assets/images/product/medium-size/Necklaces_1.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center center",
          height: "80vh",
        }}
      ></Container>
      <div className="py-5 prodListHeading">
        {/* <span>Latest</span> */}
        <h2>All Necklaces</h2>
        <Breadcrumb className=" d-flex justify-content-center">
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Necklaces </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Container fluid className="py-3 ">
        <Row className="align-items-center mx-0">
          {/* LEFT - FILTER */}
          <Col xs={6}>
            <div
              style={{ cursor: "pointer" , fontSize:"14px", color:"#000"}}
              onClick={() => setShowFilter(true)}
            >
              <i className="bi bi-funnel"></i> FILTER
            </div>
          </Col>

          {/* RIGHT - SORT DROPDOWN */}
          <Col xs={6} className="text-end">
            <Dropdown align="end">
              <Dropdown.Toggle variant="light" size="sm">
                Best selling
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>Best Selling</Dropdown.Item>
                <Dropdown.Item>Price: Low to High</Dropdown.Item>
                <Dropdown.Item>Price: High to Low</Dropdown.Item>
                <Dropdown.Item>Newest</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
      </Container>

      {/* LEFT SIDE FILTER PANEL */}
      <Offcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        placement="start"
      >
        <Offcanvas.Header className="justify-content-between">
          <Offcanvas.Title>Filter</Offcanvas.Title>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowFilter(false)}
          ></button>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <h6>Category</h6>
          <Form.Check label="Earrings" />
          <Form.Check label="Necklaces" />

          <h6 className="mt-3">Price</h6>
          <Form.Check label="Under ₹1000" />
          <Form.Check label="₹1000 - ₹3000" />

          <Button className="mt-3 w-100">Apply Filter</Button>
        </Offcanvas.Body>
      </Offcanvas>
      <Container fluid>
        <Row className="g-1 mx-0">
          {products.map((item) => (
            <Col key={item.id} xs={6} sm={6} md={4} lg={3} className="mb-4">
              <div className="product-card">
                {/* <span className="offer-badge">Buy 1 Get 1</span> */}

                <div className="image-wrapper">
                  <img src={item.img} alt="" className="main-img" />
                  <img src={item.hoverImg} alt="" className="hover-img" />
                </div>

                <div className="wishlist-icon">
                  <i className="bi bi-heart"></i>
                </div>

                <div className="product-info">
                  <h6 className="product-name">{item.name}</h6>

                  <div className="price-section">
                    <span className="discount-price">
                      ₹{item.discountPrice}
                    </span>
                    <span className="original-price">₹{item.price}</span>
                  </div>

                  <button className="add-to-cart-btn">Add to Cart</button>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ProductList;
